<table
  *ngIf="rows?.length > 0"
  class="table table--base-size table--secondary"
  edsSpacing="sm"
>
  <thead class="table__thead">
    <tr class="table__tr">
      <th class="table__th">&nbsp;</th>
      <th class="table__th bold text-align-right">
        <strong>{{ "products.fund" | translate: fundId }}</strong>
      </th>
      <th class="table__th bold text-align-right">
        <strong>{{ "products.benchmark" | translate: fundId }}</strong>
        <button
          class="print-hidden"
          edsTooltip
          [tooltipContent]="benchmark.name"
          [tooltipAriaLabel]="'products.benchmark' | translate"
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
    </tr>
  </thead>
  <tbody class="table__body">
    <tr *ngFor="let row of rows">
      <td class="table__td">
        {{ row.label }}
        <eds-footnote [placement]="row.caveatPlacement"></eds-footnote>
        <eds-footnote [placement]="row.secondaryCaveatPlacement"></eds-footnote>
        <span edsNoWrap>
          <button
            *ngIf="row.tooltip"
            class="print-hidden"
            edsTooltip
            [tooltipContent]="row.tooltip"
            tooltipType="medium"
            [tooltipAriaLabel]="row.label"
            [tooltipButton]="true"
          >
            <eds-icon type="info" size="small"></eds-icon>
          </button>
        </span>
        <div *ngIf="row.asOfDate">
          <small class="table__as-of small">
            {{ row.asOfLabel }}
            {{ row.asOfDate }}
            {{ row.updateFrequency }}
          </small>
        </div>
      </td>
      <td class="table__td text-align-right">
        <strong class="bold">{{ row.val }}</strong>
      </td>
      <td class="table__td text-align-right">
        <strong class="bold">{{ row.bmVal }}</strong>
      </td>
    </tr>
  </tbody>
</table>
